import { apiFetch } from "./client";

export type SearchHit = {
  kind: "PRODUCT" | "NEWS" | "FAQ" | "TUTORIAL" | "MATERIAL" | "TM_TASK" | "TM_PROJECT" | "TM_MEETING";
  id: string;
  title: string;
  snippet: string | null;
  href: string;
};

export type GlobalSearchResults = {
  term: string;
  products: SearchHit[];
  news: SearchHit[];
  faq: SearchHit[];
  tutorials: SearchHit[];
  materials: SearchHit[];
  tmTasks: SearchHit[];
  tmProjects: SearchHit[];
  tmMeetings: SearchHit[];
};

export const searchApi = {
  search: (q: string, locale = "en") =>
    apiFetch<GlobalSearchResults>(
      `/search?q=${encodeURIComponent(q)}&locale=${encodeURIComponent(locale)}`,
    ),
};

export function totalHits(results: GlobalSearchResults): number {
  return (
    results.products.length +
    results.news.length +
    results.faq.length +
    results.tutorials.length +
    results.materials.length +
    results.tmTasks.length +
    results.tmProjects.length +
    results.tmMeetings.length
  );
}

/**
 * Picks the first hit across all categories in priority order. TM hits come
 * before generic content because internal users tend to look for their own
 * tasks/projects first.
 */
export function firstHit(results: GlobalSearchResults): SearchHit | null {
  return (
    results.tmTasks[0] ??
    results.tmProjects[0] ??
    results.tmMeetings[0] ??
    results.products[0] ??
    results.news[0] ??
    results.faq[0] ??
    results.tutorials[0] ??
    results.materials[0] ??
    null
  );
}
